import React, { useState } from "react";
import { User, UserCheck } from "lucide-react";

import {
  Phone,
  Mail,
  MapPin,
  Clock,
  Send,
  CheckCircle,
  AlertCircle,
  Loader2,
  Facebook,
  Twitter,
  Instagram,
  Linkedin,
} from "lucide-react";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    loanType: "personal",
    amount: "",
    message: "",
  });

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submissionError, setSubmissionError] = useState(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

    if (submissionError) {
      setSubmissionError(null);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmissionError(null);

    try {
      if (
        !formData.name.trim() ||
        !formData.email.trim() ||
        !formData.phone.trim()
      ) {
        throw new Error("Please fill in all required fields");
      }

      const phoneRegex = /^[+]?[0-9\s\-\(\)]{10,15}$/;
      if (!phoneRegex.test(formData.phone)) {
        throw new Error("Please enter a valid phone number");
      }

      // Validate message length (backend requires minimum 10 characters)
      if (formData.message.trim().length < 10) {
        throw new Error("Please enter a message with at least 10 characters");
      }

      const contactData = {
        name: formData.name.trim(),
        email: formData.email.trim(),
        phone: formData.phone.trim(),
        loanType: formData.loanType,
        loanAmount: formData.amount ? parseFloat(formData.amount) : null,
        message: formData.message.trim(),
      };

      console.log("Submitting contact form with data:", contactData);
      // const response = await apiService.submitContactForm(contactData);
      const response = { success: true }; // Simulated response

      console.log("Contact form submitted successfully:", response);
      setIsSubmitted(true);

      setTimeout(() => {
        setIsSubmitted(false);
        setFormData({
          name: "",
          email: "",
          phone: "",
          loanType: "personal",
          amount: "",
          message: "",
        });
      }, 5000);
    } catch (error) {
      console.error("Error submitting contact form:", error);
      // Handle different types of errors
      let errorMessage = "Failed to submit enquiry. Please try again.";

      if (error.message) {
        errorMessage = error.message;
      } else if (typeof error === "string") {
        errorMessage = error;
      } else if (error.detail) {
        errorMessage = error.detail;
      }

      setSubmissionError(errorMessage);
    } finally {
      setIsSubmitting(false);
    }
  };

  const contactInfo = [
    {
      icon: <Phone className="h-6 w-6" />,
      title: "Phone Number",

      // ⬇️ details can now include plain text or full HTML
      details: [
        `
      <div class="flex items-center gap-2">
        <span class="font-medium text-gray-700">022 69718828</span>

        <a href="https://api.whatsapp.com/send/?phone=+9102269718828&text=hi"
          target="_blank"
          rel="noopener noreferrer"
          class="flex items-center gap-1 text-green-600 font-medium hover:underline"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 24 24">
            <path d="M12 .5C5.648.5.5 5.648.5 12c0 2.139.563 4.164 1.633 5.967L.5 23.5l5.68-1.566A11.46 11.46 0 0 0 12 23.5c6.352 0 11.5-5.148 11.5-11.5S18.352.5 12 .5zm0 21c-1.834 0-3.61-.498-5.16-1.44l-.37-.22-3.37.93.92-3.29-.24-.38A9.42 9.42 0 0 1 2.5 12C2.5 6.77 6.77 2.5 12 2.5s9.5 4.27 9.5 9.5-4.27 9.5-9.5 9.5zm5.07-6.777c-.276-.138-1.643-.81-1.898-.902-.255-.092-.442-.138-.63.138-.185.277-.724.902-.888 1.088-.163.185-.325.208-.601.069-.276-.138-1.165-.43-2.218-1.37-.82-.731-1.372-1.634-1.535-1.91-.163-.277-.018-.426.122-.564.125-.124.276-.324.414-.486.137-.163.184-.277.276-.462.092-.185.046-.347-.023-.485-.069-.139-.63-1.52-.863-2.084-.227-.545-.458-.47-.63-.48-.163-.008-.347-.01-.53-.01-.184 0-.485.069-.74.347-.255.277-.97.948-.97 2.31s.993 2.679 1.13 2.865c.138.185 1.954 3.04 4.868 4.166.68.294 1.21.47 1.623.604.681.217 1.3.186 1.79.112.546-.082 1.643-.671 1.876-1.319.232-.648.232-1.203.163-1.32-.07-.115-.254-.185-.53-.324z"/>
          </svg>
          WhatsApp
        </a>
      </div>
    `,
      ],

      detailType: "phone",
      subtext: "Monday to Saturday, 9 AM to 6 PM",
    },
    {
      icon: <Mail className="h-6 w-6" />,
      title: "Email Address",
      details: ["support@pfilfinance.com"],
      detailType: "email",
      subtext: "We'll respond within 24 hours",
    },
    {
      icon: <UserCheck className="h-6 w-6" />,
      title: "Grievance Officer",
      details: ["grievance@pfilfinance.com"],
      detailType: "email",
      subtext: `
      <div class="flex items-center gap-2">
        <span class="font-medium text-gray-700">+91 8080505194</span>
      </div>
    `,
    },
    {
      icon: <User className="h-6 w-6" />,
      title: "Nodal officer",
      details: ["grievance@pfilfinance.com"],
      detailType: "email",
      subtext: "+918080505194",
    },
    {
      icon: <MapPin className="h-6 w-6" />,
      title: "Registered Office",
      details: [
        "909, SUKHSAGAR COMPLEX,",
        "NR. FORTUNE LANDMARK HOTEL,",
        "USMANPURA, AHMEDABAD,",
        "Gujarat, India - 380013",
      ],
      detailType: "address",
      subtext: "Visit us during business hours",
    },
    {
      icon: <Clock className="h-6 w-6" />,
      title: "Business Hours",
      details: [
        "Monday - Friday: 9:00 AM - 6:00 PM",
        "Saturday: 9:00 AM - 2:00 PM",
      ],
      detailType: "hours",
      subtext: "Closed on Sundays and public holidays",
    },
  ];

  const loanTypes = [
    { value: "personal", label: "Personal Loan" },
    { value: "home", label: "Home Loan" },
    { value: "lap", label: "Loan Against Property" },
    { value: "gold", label: "Gold Loan" },
  ];

  const branches = [
    {
      city: "Ahmedabad (Registered Office)",
      address:
        "909, SUKHSAGAR COMPLEX, NR. FORTUNE LANDMARK HOTEL, USMANPURA, AHMEDABAD, Gujarat - 380013",
      phone: "022 69718828",
      manager: "Regional Manager",
    },
    {
      city: "Pune (Corporate Office)",
      address:
        "Office-B 6010, H-core Solitaire Business Hub, Viman Nagar, Pune, Maharashtra 411014",
      phone: "022 69718828",
      manager: "Branch Manager",
    },
    {
      city: "Sinnar (Branch)",
      address:
        "Ground Floor, Sai Anand Pride B, Duber Naka, Sinnar, Nashik - 422103",
      phone: "022 69718828",
      manager: "Branch Manager",
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-blue-50 to-indigo-100 py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto text-center">
          <div className="space-y-8">
            <div className="flex justify-center mb-8">
              <img
                src="https://customer-assets.emergentagent.com/job_persian-indigo-fin/artifacts/d9xink6u_2897_Logo_V-PNG-01.png"
                alt="PFIL Finance Logo"
                className="h-20 w-auto"
              />
            </div>
            <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 leading-tight">
              Get in <span style={{ color: "#340C7F" }}>Touch</span>
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              We're here to help! Reach out to us for any queries regarding
              loans, services, or support. Ready to take the next step? Contact
              our expert team for personalized loan solutions.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Form & Info Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            {/* Contact Form */}
            <div className="bg-white rounded-2xl shadow-xl p-8">
              <div className="space-y-6">
                <div className="space-y-2">
                  <h2 className="text-2xl font-bold text-gray-900">
                    Loan Enquiry
                  </h2>
                  <p className="text-gray-600">
                    Fill out the form below and we'll get back to you within 24
                    hours.
                  </p>
                </div>

                {submissionError && (
                  <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                    <div className="flex items-center space-x-2 text-red-700">
                      <AlertCircle className="h-5 w-5" />
                      <span className="text-sm">{submissionError}</span>
                    </div>
                  </div>
                )}

                {isSubmitted ? (
                  <div className="text-center py-8 space-y-4">
                    <CheckCircle className="h-16 w-16 mx-auto text-green-500" />
                    <h3 className="text-xl font-semibold text-gray-900">
                      Thank You!
                    </h3>
                    <div className="space-y-2">
                      <p className="text-gray-600">
                        Your loan enquiry has been submitted successfully. Our
                        team will contact you within 24 hours.
                      </p>
                      <div className="inline-flex items-center space-x-2 px-4 py-2 bg-green-100 text-green-700 rounded-full text-sm">
                        <CheckCircle className="h-4 w-4" />
                        <span>
                          Enquiry ID: PFIL-{Date.now().toString().slice(-6)}
                        </span>
                      </div>
                    </div>
                  </div>
                ) : (
                  <form onSubmit={handleSubmit} className="space-y-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div>
                        <label
                          htmlFor="name"
                          className="block text-sm font-medium text-gray-700 mb-2"
                        >
                          Full Name *
                        </label>
                        <input
                          type="text"
                          id="name"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          required
                          disabled={isSubmitting}
                          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                          placeholder="Enter your full name"
                        />
                      </div>

                      <div>
                        <label
                          htmlFor="email"
                          className="block text-sm font-medium text-gray-700 mb-2"
                        >
                          Email Address *
                        </label>
                        <input
                          type="email"
                          id="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          required
                          disabled={isSubmitting}
                          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                          placeholder="Enter your email"
                        />
                      </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div>
                        <label
                          htmlFor="phone"
                          className="block text-sm font-medium text-gray-700 mb-2"
                        >
                          Phone Number *
                        </label>
                        <input
                          type="tel"
                          id="phone"
                          name="phone"
                          value={formData.phone}
                          onChange={handleChange}
                          required
                          disabled={isSubmitting}
                          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                          placeholder="Enter your phone number"
                        />
                      </div>

                      <div>
                        <label
                          htmlFor="loanType"
                          className="block text-sm font-medium text-gray-700 mb-2"
                        >
                          Loan Type *
                        </label>
                        <select
                          id="loanType"
                          name="loanType"
                          value={formData.loanType}
                          onChange={handleChange}
                          required
                          disabled={isSubmitting}
                          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                          {loanTypes.map((type) => (
                            <option key={type.value} value={type.value}>
                              {type.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div>
                      <label
                        htmlFor="amount"
                        className="block text-sm font-medium text-gray-700 mb-2"
                      >
                        Loan Amount Required (₹)
                      </label>
                      <input
                        type="number"
                        id="amount"
                        name="amount"
                        value={formData.amount}
                        onChange={handleChange}
                        min="500"
                        disabled={isSubmitting}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                        placeholder="Enter loan amount in ₹"
                      />
                    </div>

                    <div>
                      <label
                        htmlFor="message"
                        className="block text-sm font-medium text-gray-700 mb-2"
                      >
                        Additional Message
                      </label>
                      <textarea
                        id="message"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        rows={4}
                        disabled={isSubmitting}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                        placeholder="Tell us more about your requirements... (minimum 10 characters)"
                      />
                    </div>

                    <button
                      type="submit"
                      disabled={isSubmitting}
                      className="w-full flex items-center justify-center px-6 py-4 text-white font-medium rounded-lg hover:opacity-90 transition-opacity shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
                      style={{ backgroundColor: "#340C7F" }}
                    >
                      {isSubmitting ? (
                        <>
                          <Loader2 className="mr-2 h-5 w-5 animate-spin" />
                          Submitting...
                        </>
                      ) : (
                        <>
                          Submit Enquiry
                          <Send className="ml-2 h-5 w-5" />
                        </>
                      )}
                    </button>
                  </form>
                )}
              </div>
            </div>

            {/* Contact Information */}
            <div className="space-y-8">
              <div className="space-y-4">
                <h2 className="text-2xl font-bold text-gray-900">
                  Contact Information
                </h2>
                <p className="text-gray-600">
                  Reach out to us through any of the following channels. We're
                  here to help!
                </p>
              </div>

              <div className="grid grid-cols-1 gap-6">
                {contactInfo.map((info, index) => (
                  <div
                    key={index}
                    className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow"
                  >
                    <div className="flex items-start space-x-4">
                      <div className="flex-shrink-0">
                        <div
                          className="w-12 h-12 rounded-lg flex items-center justify-center text-white"
                          style={{ backgroundColor: "#340C7F" }}
                        >
                          {info.icon}
                        </div>
                      </div>
                      <div className="flex-1">
                        <h3 className="text-lg font-semibold text-gray-900 mb-2">
                          {info.title}
                        </h3>

                        {info.details.map((detail, idx) => {
                          const cleanedDetail = detail.trim();
                          const isHTML = /<[^>]+>/.test(cleanedDetail); // detect HTML

                          return (
                            <div key={idx}>
                              {isHTML ? (
                                <div
                                  className="text-gray-700 font-medium"
                                  dangerouslySetInnerHTML={{
                                    __html: cleanedDetail,
                                  }}
                                />
                              ) : info.detailType === "phone" ? (
                                <a
                                  href={`tel:${cleanedDetail.replace(
                                    /\s/g,
                                    ""
                                  )}`}
                                  className="text-gray-700 font-medium hover:text-purple-600 transition-colors hover:underline"
                                >
                                  {cleanedDetail}
                                </a>
                              ) : info.detailType === "email" ? (
                                <a
                                  href={`mailto:${cleanedDetail}`}
                                  className="text-gray-700 font-medium hover:text-purple-600 transition-colors hover:underline"
                                >
                                  {cleanedDetail}
                                </a>
                              ) : (
                                <p className="text-gray-700 font-medium">
                                  {cleanedDetail}
                                </p>
                              )}
                            </div>
                          );
                        })}

                        {info.subtext && (
                          <div
                            className="text-sm text-gray-500 mt-1"
                            dangerouslySetInnerHTML={{ __html: info.subtext }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Social Media Section */}
              <div className="bg-white rounded-xl p-6 shadow-lg">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">
                  Connect With Us
                </h3>
                <p className="text-gray-600 mb-6">
                  Follow us on social media for updates, financial tips, and
                  news
                </p>
                <div className="flex justify-center space-x-6">
                  <a
                    href="https://www.facebook.com/profile.php?id=61578619573930"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center w-12 h-12 rounded-full text-white hover:scale-110 transition-all duration-300 shadow-lg hover:shadow-xl"
                    style={{ backgroundColor: "#1877F2" }}
                    aria-label="Follow PFIL Finance on Facebook"
                  >
                    <Facebook className="h-6 w-6" />
                  </a>
                  <a
                    href="https://x.com/pfilfinance"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center w-12 h-12 rounded-full text-white hover:scale-110 transition-all duration-300 shadow-lg hover:shadow-xl"
                    style={{ backgroundColor: "#000000" }}
                    aria-label="Follow PFIL Finance on X (Twitter)"
                  >
                    <Twitter className="h-6 w-6" />
                  </a>
                  <a
                    href="https://www.instagram.com/pfilfinance/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center w-12 h-12 rounded-full text-white hover:scale-110 transition-all duration-300 shadow-lg hover:shadow-xl"
                    style={{ backgroundColor: "#E4405F" }}
                    aria-label="Follow PFIL Finance on Instagram"
                  >
                    <Instagram className="h-6 w-6" />
                  </a>
                  <a
                    href="https://www.linkedin.com/company/pfilfinance/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center w-12 h-12 rounded-full text-white hover:scale-110 transition-all duration-300 shadow-lg hover:shadow-xl"
                    style={{ backgroundColor: "#0077B5" }}
                    aria-label="Connect with PFIL Finance on LinkedIn"
                  >
                    <Linkedin className="h-6 w-6" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Branch Locations */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center space-y-4 mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900">
              Our <span style={{ color: "#340C7F" }}>Branch Locations</span>
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Visit our branches across major cities in India for personalized
              service and support.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {branches.map((branch, index) => (
              <div
                key={index}
                className="bg-gray-50 rounded-xl p-6 space-y-4 hover:shadow-lg transition-shadow"
              >
                <div className="text-center">
                  <h3
                    className="text-xl font-semibold"
                    style={{ color: "#340C7F" }}
                  >
                    {branch.city}
                  </h3>
                </div>

                <div className="space-y-3 text-sm">
                  <div className="flex items-start space-x-2">
                    <MapPin className="h-4 w-4 text-gray-500 mt-0.5 flex-shrink-0" />
                    <p className="text-gray-700">{branch.address}</p>
                  </div>

                  <div className="flex items-center space-x-2">
                    <Phone className="h-4 w-4 text-gray-500 flex-shrink-0" />
                    <a
                      href={`tel:${branch.phone.replace(/\s/g, "")}`}
                      className="text-gray-700 hover:text-purple-600 transition-colors hover:underline"
                    >
                      {branch.phone}
                    </a>
                  </div>

                  <div className="pt-2 border-t border-gray-200">
                    <p className="text-gray-600">
                      <span className="font-medium">Contact:</span>{" "}
                      {branch.manager}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
